import { ResolverTag } from '@ps/web-core-enums';
import { InfoIcon, Translation } from '@ps/web-shared-components';
import { StarsInfo } from '@ps/web-shared-ui';
import React from 'react';
import { useSelector } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import { select } from '@swf/core/store';

import styles from '../../../shared.scss';
import AccountDate from '../../AccountDate/AccountDate';
import type { ExclusionType } from '../../definitions';
import DefaultSelfExclusionResponse from '../DefaultSelfExclusionResponse/DefaultSelfExclusionResponse';

import {
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_11,
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_12,
  TXTWCL_When_it_ends_you_will_need_to__ELL,
  TXTWCL_When_your_break_endsX_you_will_ELL,
  TXTWCL_XIf_you_opted_for_the_24_hour__ELL,
  TXTWCL_XbXSorryX_we_canXt_process_you_ELL,
  TXTWCL_XbXYour_request_to_take_a_brea_ELL,
  TXTWCL_Your_account_has_been_restrict_ELL_2
} from './ExclusionResponseDE.messages.json';

interface Props {
  error?: boolean;
  confirmationEndDate?: string;
  showExclusionConfirmationDE?: boolean;
  daysRequested?: number;
  exclusionType?: ExclusionType;
  endDate: Date;
}

const ExclusionResponseDE: React.FC<Props> = ({
  error,
  confirmationEndDate,
  showExclusionConfirmationDE,
  daysRequested,
  exclusionType,
  endDate
}) => {
  const nationalExclusion = useSelector(select.account.bannedByRegulator);

  switch (true) {
    case error:
      return (
        <StarsInfo type="error" className={styles.infoBox}>
          <span className={styles.infoBoxHeading}>
            <InfoIcon className={styles.infoError} />
            <Translation tagName="div" {...TXTWCL_XbXSorryX_we_canXt_process_you_ELL} />
          </span>
          <Translation {...TXTWCL_Your_account_has_been_restrict_ELL_2} />
        </StarsInfo>
      );
    case showExclusionConfirmationDE:
      return (
        <StarsInfo type="confirmation" className={styles.infoBox}>
          <span className={styles.infoBoxHeading}>
            <InfoIcon className={styles.infoSuccess} />
            <Translation tagName="div" {...TXTWCL_XbXYour_request_to_take_a_brea_ELL} />
          </span>
          <Translation
            {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_12}
            values={{
              0: (
                <b>
                  <AccountDate date={confirmationEndDate ?? new Date()} />
                </b>
              )
            }}
          />{' '}
          <Translation {...TXTWCL_When_your_break_endsX_you_will_ELL} />
        </StarsInfo>
      );
    case nationalExclusion:
      return (
        <>
          <Translation {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_11} />{' '}
          <Translation
            {...TXTWCL_When_it_ends_you_will_need_to__ELL}
            values={{
              a: (msg: React.ReactNode) => (
                <ResolverLink resolverTag={ResolverTag.OasisReinstate}>{msg}</ResolverLink>
              )
            }}
          />{' '}
          <Translation {...TXTWCL_XIf_you_opted_for_the_24_hour__ELL} />
        </>
      );
    default:
      return (
        <DefaultSelfExclusionResponse
          daysRequested={daysRequested}
          exclusionType={exclusionType}
          endDate={endDate}
        />
      );
  }
};

export default ExclusionResponseDE;
